import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from "vue";
  import store from "@/store";
  import plural from "@/features/plural";
  import { UserQuoteSelectionInterface } from "@/types/UserQuoteSelectionInterface";
  import { useToast } from "vue-toastification";
  import HouseSelectionsCard from "@/components/builder/HouseSelectionsCard.vue";
  import { SelectionStepsIndexEnum } from "@/enums/BuilderStepsIndex";
  import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import CustomizeHouseSlider from "@/components/builder/CustomizeHouseSlider.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { LotActionInterface } from "@/types/LotActionInterface";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import BuilderLotDetails from "@/components/builder/BuilderLotDetails.vue";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";

  interface Props {
    houseDesign: HouseDesignInterface;
    isOpen: boolean;
    estate: EstateInterface;
    lot: LotActionInterface;
    lotForBuilder: LotMapInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderQuotesLists',
  props: {
    houseDesign: {},
    isOpen: { type: Boolean },
    estate: {},
    lot: {},
    lotForBuilder: {}
  },
  emits: [
    "close",
    "addQuote",
    "updateQuoteBuilder",
    "updateQuoteDesignAndFloorplan",
    "updateQuoteFacade",
    "deleteQuote",
    "toRequestQuoteForm",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);
  const props = __props;
  const sliderImages = ref<string[]>([]);

  const emits = __emit;

  const toast = useToast();
  const selectedQuote = computed(
    () => store.getters["builder/getSelectedSelection"]
  );

  const onClose = () => {
    emits("close");
  };

  const userSelections = computed(() => {
    return store.state.builder.userSelectionDesign;
  });

  const selectedHouseDesign = computed(() => props.houseDesign);

  const setSliderImages = () => {
    const facadeUrl = selectedQuote.value?.facade?.url;

    if (facadeUrl) {
      sliderImages.value = [facadeUrl];
    }
  };

  const checkCanAdd = () => {
    const hasIncompleteQuotes = userSelections.value.some(
      (selection) => selection.currentStep !== CustomizeHouseStepsEnum.EXTERIOR
    );

    return !hasIncompleteQuotes;
  };

  const onGetMoreQuotes = () => {
    if (!checkCanAdd()) {
      toast.error("Please complete step 4 before adding any additional quotes");
      return;
    }

    emits("addQuote");
  };

  const onUpdateUserSelectionBuilder = (
    selection: UserQuoteSelectionInterface
  ) => {
    emits("updateQuoteBuilder", selection);
  };

  const onUpdateUserSelectionDesignAndFloorplan = (
    selection: UserQuoteSelectionInterface
  ) => {
    emits("updateQuoteDesignAndFloorplan", selection);
  };

  const onUpdateUserSelectionFacade = (
    selection: UserQuoteSelectionInterface
  ) => {
    emits("updateQuoteFacade", selection);
  };

  const onDeleteUserSelection = (selectionId: number) => {
    if (store.state.builder.userSelectionDesign.length === 1) {
      toast.error("You must have at least one quote.");
      return;
    }

    emits("deleteQuote", selectionId);
  };
  const checkStoreHasValues = () =>
    store.getters["builder/hasUserSelectionDesignEmptyValues"];
  const submit = () => {
    if (checkStoreHasValues()) {
      toast.error(
        "Please ensure that all selections are filled in your quotes"
      );
      return;
    }

    onClose();
    emits("toRequestQuoteForm");
  };

  watch(
    () => userSelections.value,
    () => {
      userSelections.value.forEach((selection) => {
        if (selection.facade && selection.facade.url) {
          setSliderImages();
        }
      });
    },
    { deep: true, immediate: true }
  );

  onMounted(() => {
    setSliderImages();
  });

const __returned__ = { isDesktop, props, sliderImages, emits, toast, selectedQuote, onClose, userSelections, selectedHouseDesign, setSliderImages, checkCanAdd, onGetMoreQuotes, onUpdateUserSelectionBuilder, onUpdateUserSelectionDesignAndFloorplan, onUpdateUserSelectionFacade, onDeleteUserSelection, checkStoreHasValues, submit, computed, onMounted, ref, watch, get store() { return store }, get plural() { return plural }, get UserQuoteSelectionInterface() { return UserQuoteSelectionInterface }, get useToast() { return useToast }, HouseSelectionsCard, get SelectionStepsIndexEnum() { return SelectionStepsIndexEnum }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get HouseDesignInterface() { return HouseDesignInterface }, HouseFeatures, CustomizeHouseSlider, get EstateInterface() { return EstateInterface }, get LotActionInterface() { return LotActionInterface }, get useIsDesktop() { return useIsDesktop }, BuilderLotDetails, get LotMapInterface() { return LotMapInterface }, get formatMeters() { return formatMeters } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})